/**
 *
 * @name script
 * @author MohammedSaleem
 * @fileOverview generic script that links different css functionality across aplication,
 * viz on-button-click,popup.
 */

import $ from 'jquery';

$(document).ready(function () {
   let parentEle = $('body');
   let fun = {
      default: function () {
         parentEle.on('click', '.popup .close', function (e) {
            $('.popup').fadeOut(300);
            $('.background').fadeOut(300);
         });
      },
      dropDown: function () {
         parentEle.on('click', '.drop-down:not(.disabled) .drop-down-header', function (e) {
            e.stopPropagation();
            if (!$(this).parent().hasClass('open')) {
               $('.drop-down').removeClass('open');
               $(this).parents().eq(0).addClass('open');
            } else {
               $(this).parents().eq(0).removeClass('open');
            }
         });
         parentEle.on('click', '.drop-down:not(.multi-select) .drop-down-list li', function (e) {
            $(this).parents().eq(2).removeClass('open');
         });
      },
      autoFocus: function () {
         parentEle.on('focus', '.auto-complete .auto-complete-header input', function (e) {
            e.stopPropagation();
            if (!$(this).parent().eq(1).hasClass('open')) {
               $('.auto-complete').removeClass('open');
               $(this).parents().eq(1).addClass('open');
            }
         });
         parentEle.on('click', '.auto-complete .auto-complete-list li', function (e) {
            $(this).parents().eq(2).removeClass('open');
         });
      },
      popup: function (btn, popup) {
         parentEle.on('click', btn, function (e) {
            e.stopPropagation();
            $('.popup').fadeOut(0);
            $('.background').fadeIn(300);
            $(popup).fadeIn(300);
            window.scroll({
               top: 0,
               behavior: 'smooth'
            });
         });
      },
      accordion: function () {
         parentEle.on('click', '.accordion-sec .accordion-head',
            function (e) {
               e.stopPropagation();
               if ($(this).parent().hasClass('expand') || $(this).parent().hasClass('open')) {
                  $(this).parent()
                     .removeClass('expand')
                     .removeClass('open')
               } else {
                  $(this).parent()
                     .addClass('expand')
               }
            });
      },
      defaultClick: function () {
         $(document).click(function () {
            $('.drop-down, .auto-complete').removeClass('open');
         });
      },
      preventDefaultClicks: function () {
         let selectors = '.drop-down, .auto-complete';
         parentEle.on('click', selectors, function (e) {
            e.stopPropagation();
         });
      },
   };
   fun.default();
   fun.dropDown();
   fun.autoFocus();
   fun.accordion();
   fun.preventDefaultClicks();
   fun.defaultClick();
});
